export default {
  namespaced: true,
  state: {
    components: [] // 组件化配置
  },
  mutations: {
    setComponents(state, params) {
      state.components = params
    },
  },
  actions: {
    getComponents({commit}, params) {
      commit('setComponents', params)
    },
  }
}
